// extracted by mini-css-extract-plugin
export default {"genLoadingState":"GenLoadingState_genLoadingState__wYNzD","gradientBorder":"GenLoadingState_gradientBorder__RtKN5","moveGradient":"GenLoadingState_moveGradient__mnNKY"};